/**
 *
 * @type {{read: ((key: string) => any); write: ((key: string, value: string, days?: number) => any)}}
 */
export const Cookie = {
	/**
	 * read cookie by key
	 *
	 * @param {string} key
	 */
	get: (key: string) => {
		return ('; ' + document.cookie)
			.split('; ' + key + '=')
			.pop()
			.split(';')
			.shift();
	},
	/**
	 * write cookie
	 *
	 * @param {string} key
	 * @param {string} value
	 * @param {number} days
	 */
	set: (key: string, value: string, days: number = 14) => {
		let d = new Date();
		d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
		let expires = "expires=" + d.toUTCString();
		document.cookie = key + "=" + value + ";" + expires + ";path=/";
	}
};


/**
 * animated scrolling
 *
 * @param {number} scrollTargetY
 * @param {number} speed pixels scrolled per second
 * @param {string} easing easing equation to use
 */
export const scrollToY = (scrollTargetY: number, speed: number = 2000, easing: string = 'easeOutSine') => {

	let scrollY = window.scrollY || document.documentElement.scrollTop,
		currentTime = 0;

	// min 100ms, max 2000ms
	let time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, 2));

	// https://github.com/danro/easing-js/blob/master/easing.js
	let easingEquations = {
		easeOutSine: (pos) => {
			return Math.sin(pos * (Math.PI / 2));
		},
		easeInOutSine: (pos) => {
			return (-0.5 * (Math.cos(Math.PI * pos) - 1));
		},
		easeInOutQuint: (pos) => {
			if ((pos /= 0.5) < 1) {
				return 0.5 * Math.pow(pos, 5);
			}
			return 0.5 * (Math.pow((pos - 2), 5) + 2);
		}
	};

	// animation loop
	const tick = () => {
		currentTime += 1 / 60;

		let p = currentTime / time;
		let t = easingEquations[easing](p);

		if (p < 1) {
			window.requestAnimationFrame(tick);
			window.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t));
		} else {
			window.scrollTo(0, scrollTargetY);
		}
	};

	// call it once to get started
	tick();
};

/**
 * animated scrolling
 *
 * @param {number} scrollTargetY
 * @param {number} speed pixels scrolled per second
 * @param {string} easing easing equation to use
 */
export const scrollToYInsideElement = (element: HTMLElement, scrollTargetY: number, speed: number = 2000, easing: string = 'easeOutSine') => {

	let scrollY = element.scrollTop,
		currentTime = 0;

	// min 100ms, max 2000ms
	let time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, 2));

	// https://github.com/danro/easing-js/blob/master/easing.js
	let easingEquations = {
		easeOutSine: (pos) => {
			return Math.sin(pos * (Math.PI / 2));
		},
		easeInOutSine: (pos) => {
			return (-0.5 * (Math.cos(Math.PI * pos) - 1));
		},
		easeInOutQuint: (pos) => {
			if ((pos /= 0.5) < 1) {
				return 0.5 * Math.pow(pos, 5);
			}
			return 0.5 * (Math.pow((pos - 2), 5) + 2);
		}
	};

	// animation loop
	const tick = () => {
		currentTime += 1 / 60;

		let p = currentTime / time;
		let t = easingEquations[easing](p);

		if (p < 1) {
			window.requestAnimationFrame(tick);
			element.scrollTop = scrollY + ((scrollTargetY - scrollY) * t);
		} else {
			element.scrollTop = scrollTargetY;
		}
	};

	// call it once to get started
	tick();
};

/**
 * match device configuration
 *
 * @type {{isSmallSizeDevice: (() => boolean); isMediumSizeDevice: (() => boolean); isLargeSizeDevice: (() => boolean); isMobileDevice: (() => boolean); isInternetExplorer: (() => boolean)}}
 */
export const DeviceMatcher = {
	isSmallSizeDevice: () => {
		return window.matchMedia('(max-width: 62rem)').matches;
	},

	isMediumSizeDevice: () => {
		return window.matchMedia('(min-width: 62rem and max-width: 75rem)').matches;
	},

	isLargeSizeDevice: () => {
		return window.matchMedia('(min-width: 75rem)').matches;
	},

	isDeviceLargerAs: (measure: string) => {
		return window.matchMedia('(min-width: ' + measure + ')').matches;
	},

	isMobileDevice: () => {
		return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	},

	isInternetExplorer: () => {
		return /MSIE/i.test(navigator.userAgent);
	}
};




// WEBPACK FOOTER //
// ./src/js/utilities/sink.tsx